export default "__VITE_ASSET__DvD8I_Hn__"